import React, { FC } from 'react';
import i18n from 'i18n';
import styled from 'styled-components';

import { ModalProps } from '../types';
import { RowsContainer } from '../Common';
import Modal from '../../Modal/index';
import { ModalImageContainer, ModalImageContainerWithText } from '../../ImageContainer/ModalImageContainer';
import { ModalGrayText } from '../../Common';
import { AppType } from '../../../../constants';

const InstallContentContainer = styled(RowsContainer)`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 25px;
  align-items: center;
`;

const AppBannerDiv = styled.div`
  margin-bottom: 15px;
`;

const ParentAppImageContainer = styled.div`
  display: flex;
  margin-top: 15px;
  align-self: flex-start;
`;

interface InstallTileModalProps extends ModalProps {
}

export const InstallTileAndAppModal: FC<InstallTileModalProps> = ({ app, deviceName, onCancel, onSuccess, parentApp }) => (
  <Modal
    id={`InstallTileAndAppModalProps`}
    title={i18n('component.InstallTileAndAppModal.title')({ appName: app.name })}
    onClose={onCancel}
    contentCenter={
      <InstallContentContainer>
        <AppBannerDiv>
          <ModalImageContainer app={app} deviceName={deviceName} />
        </AppBannerDiv>
        <ModalGrayText>
          {i18n('component.InstallTileAndAppModal.content')({ appName: app.name, tileName: app.name})}
        </ModalGrayText>
        { parentApp && (
          <ParentAppImageContainer>
            <ModalImageContainerWithText 
              app={parentApp}
              text={parentApp.name}
              subtext={parentApp.developer.name}
              deviceName={deviceName}
            />
          </ParentAppImageContainer>
        )}
      </InstallContentContainer>
    }
    buttons={[
      {
        text: i18n('component.InstallTileAndAppModal.cancelText')(),
        onClick: onCancel,
        testType: 'cancel-button',
        id: 'uninstall-button-cancel'
      },
      {
        text: i18n('component.InstallTileAndAppModal.continueText')(),
        onClick: onSuccess,
        highlight: true,
        testType: 'install-button',
        id: 'install-button-ok'
      }
    ]}
  />
);
